import React, { Component } from "react";
import './Footer.scss';

export default class Footer extends Component {

    render() {
        return(
            <div className="footer" data-testid="footer">
            <div className="footer-text" data-testid="footer-text">Copyright 2021 <span className="tata-motors">Tata Motors</span>. All right reserved</div>
            </div>
        );
    }
}